export default __webpack_public_path__ + "static/media/cc_2.c03231a0.mp3";